import React, { Component } from "react";
import { Table, Tooltip, Button } from "antd";
import { CustomModal } from "../common/CustomModal";
import { getUserCourseList } from "../../Graphs/User/listUserCourse";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from "moment";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import PreviewTopicQuiz from "./PreviewTopicQuiz";
import EditDateModal from "./EditDateModal";
import { getUserCourseQuizDetails } from "../../Graphs/User/UserCourseQuizDetails";
import { Rate } from "antd";
import { checkPermission } from "../AdminUser/CheckPremission";

class ListUserCourseData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
      quizDetails: [],
      showCoursesModal: false,
      selectedCourse: null,
      showEditDateModal: false, // State to manage EditDateModal
      selectedItem: null,
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedUser = this.getLimitedUser.bind(this);
  }

  async getLimitedUser(pagination) {
    const { searchText } = this.props;
    console.log("tempCounter && counter --> ", this.tempCounter, this.counter);
    const start =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const end = pagination.pageSize;

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        if (searchText != null && searchText !== "") {
          //get search text props from redux store
          this.listSearchUserData(start, end);
        } else {
          //call normal user Data
          this.listUserCourseData(start, end);
        }
      }
    );
  }

  openEditDateModal = (item) => {
    this.setState({
      showEditDateModal: true,
      selectedItem: item,
    });
  };

  closeEditDateModal = () => {
    this.setState({ showEditDateModal: false, selectedItem: null });
  };

  closeModal = () => {
    this.setState({ showCoursesModal: false, selectedCourse: null });
  };

  listUserCourseData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListUserCourseData,
        setListUserDataTotal,
        type,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let userData = await getUserCourseList(
        authToken,
        { ...this.props.adminSelectedData, type },
        start,
        end
      );

      if (userData.status === 200) {
        //set user Data
        await setListUserCourseData(userData.data);
        // await setListUserCourseData(userData.data.docs);
        await setListUserDataTotal(userData.total);

        this.setState({
          isLoading: false,
          data: userData.data,
        });
      } else if (userData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };
  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedUser(pagination)
    );
  }

  formatDuration(seconds) {
    seconds = Math.floor(seconds);

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hrs > 0) parts.push(`${hrs} hour${hrs !== 1 ? "s" : ""}`);
    if (mins > 0) parts.push(`${mins} minute${mins !== 1 ? "s" : ""}`);
    if (secs > 0 || parts.length === 0)
      parts.push(`${secs} second${secs !== 1 ? "s" : ""}`);

    return parts.join(" ");
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 70,
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "Course Title",
      width: 150,
      key: "courseName",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={item && item.courses ? item.courses.name : "-"}
              >
                <div>{item && item.courses ? item.courses.name : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Start Date & Time",
      width: 100,
      key: "start_date",
      render: (text, item, index) => {
        const formattedDate = item && item.courses && item.courses.start_date
          ? moment(item.courses.start_date).format("DD MMM YYYY")
          : "-";

        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Start Date">
                <div>{formattedDate}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Current Topic",
      width: 150,
      key: "current_topic",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={
                  item && item.current_topic_details && item.current_topic_details.name
                    ? item.current_topic_details.name
                    : "-"
                }
              >
                <div>
                  {item && item.current_topic_details && item.current_topic_details.name
                    ? item.current_topic_details.name
                    : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Expected End Date",
      width: 100,
      key: "expected_end_date",
      render: (text, item, index) => {
        const formattedDate = item && item.courses && item.courses.end_date
          ? moment(item.courses.end_date).format("DD MMM YYYY")
          : "-";
        return (
          <div>
            <strong>
              {/* <Tooltip placement="bottom" title="Start Date"> */}
              <div>{formattedDate}</div>
              {/* </Tooltip> */}
            </strong>
          </div>
        );
      },
    },
    {
      title: "Average Time Spent",
      width: 100,
      key: "avg_time_spend",
      render: (text, item, index) => {
        const durationInSeconds = item.avgDuration;

        const displayDuration = durationInSeconds
          ? this.formatDuration(durationInSeconds)
          : "-";
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={displayDuration ? displayDuration : "-"}
              >
                <div>{displayDuration ? displayDuration : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Last Visit Date",
      width: 100,
      key: "accessed_date",
      render: (text, item, index) => {
        const date = item.last_visit_date;

        if (!date) {
          return <div>-</div>;
        }
        const relativeTime = moment(date).fromNow();

        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title={relativeTime}>
                <div>{relativeTime ? relativeTime : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Completion",
      width: 100,
      key: "completedAt",
      render: (text, item, index) => {
        const formattedDate =
          item && item.courses && item.courses.completedAt
            ? moment(item.courses.completedAt).format("DD MMM YYYY")
            : "-";

        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Completed Date">
                <div>{formattedDate}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Progress",
      width: 130,
      key: "progress",
      render: (text, item, index) => {
        const completedTopics = (item && item.courses && item.courses.completed_topics_count) || 0;
        const totalTopics = (item && item.courses && item.courses.topics_count) || 0;
        const progress =
          totalTopics > 0 ? (completedTopics / totalTopics) * 100 : 0;

        return (
          <Tooltip placement="bottom" title={`${progress.toFixed(2)}%`}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                minWidth: "100px",
              }}
            >
              <div
                style={{
                  height: "6px",
                  width: "100%",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  overflow: "hidden",
                  flex: 1,
                }}
              >
                <div
                  role="progressbar"
                  style={{
                    height: "100%",
                    width: `${progress}%`,
                    backgroundColor: "#3b82f6",
                    transition: "width 0.4s ease",
                  }}
                  aria-valuenow={progress}
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Review",
      width: 150,
      key: "course_review",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={
                  item && item.course_review && item.course_review.review
                    ? item.course_review.review
                    : "-"
                }
              >
                <div>
                  <Rate
                    disabled
                    defaultValue={
                      item && item.course_review && typeof item.course_review.ratings === 'number'
                        ? item.course_review.ratings
                        : 0
                    }
                    style={{ fontSize: "14px" }}
                  />
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Certificate Issue Date",
      width: 150,
      key: "certificate_issue_date",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={
                  item &&
                  item.course_certificate &&
                  item.course_certificate.insertedAt
                    ? moment(item.course_certificate.insertedAt).format(
                        "DD MMM YYYY"
                      )
                    : "-"
                }
              >
                <div>
                  {item &&
                  item.course_certificate &&
                  item.course_certificate.insertedAt
                    ? moment(item.course_certificate.insertedAt).format(
                        "DD MMM YYYY"
                      )
                    : "0"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Total Marks",
      width: 160,
      key: "score",
      render: (text, item, index) => {
        // console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={
                  item && item.courses && typeof item.courses.score === 'number' ? item.courses.score.toFixed(1) : "-"
                }
              >
                <div>
                  {item && item.courses && typeof item.courses.score === 'number' ? item.courses.score.toFixed(1) + "%" : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Course Reset",
      width: 150,
      key: "course_reset",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip
                placement="bottom"
                title={
                  item && item.reset_course_count
                    ? item.reset_course_count
                    : "0"
                }
              >
                <div>
                  {item && item.reset_course_count
                    ? item.reset_course_count
                    : "0"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Actions",
      width: 170,
      key: "action",
      render: (text, item) => (
        <div style={{ display: "inline-block", width: "100%" }}>
          {/* View Courses Button */}
          <Tooltip placement="bottom" title="View Courses">
            <Button
              shape="circle"
              icon={<EyeOutlined />}
              onClick={() => {
                const uId = item.user_id ? item.user_id : "";
                const cId = item && item.courses && item.courses.course_id
                  ? item.courses.course_id
                  : "";
                this.setState({
                  showCoursesModal: true,
                  selectedCourse: {
                    userId: uId,
                    courseId: cId,
                  },
                }, () => {
                  this.fetchData(uId, cId);
                });
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Actions",
      width: 170,
      key: "actionss",
      render: (text, item) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "user", "edit");
        let userRole = "";
        if (loginUserData && loginUserData.role) {
          userRole = loginUserData.role;
        } else {
          try {
            const serializedState = localStorage.getItem("state");
            if (serializedState) {
              const parsedState = JSON.parse(serializedState);
              if (parsedState && parsedState.auth && parsedState.auth.loginUserData) {
                userRole = parsedState.auth.loginUserData.role;
              }
            }
          } catch (e) {}
        }
        const isEditable = canEdit && userRole !== "corporate";

        return (
          <div style={{ display: "inline-block", width: "100%" }}>
            {/* Edit Date Button */}
            <Tooltip placement="bottom" title="Edit Date">
              <Button
                shape="circle"
                icon={<EditOutlined />}
                style={{ marginLeft: "10px" }} // Add spacing
                disabled={!isEditable}
                onClick={() => {
                  const uId = item.user_id ? item.user_id : "";
                  const cId = item && item.courses && item.courses.course_id
                    ? item.courses.course_id
                    : "";
                  this.setState({
                    showEditDateModal: true, // Open EditDateModal
                    selectedItem: item, // Pass selected item details
                    selectedCourse: {
                      userId: uId,
                      courseId: cId,
                    },
                  });
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  fetchData = async (userId, courseId) => {
    const { authToken } = this.props;
    const uId = userId || this.props.userId;
    const cId = courseId || this.props.courseId;
    if (!uId || !cId) return;
    try {
      const response = await getUserCourseQuizDetails(authToken, {
        userId: uId,
        courseId: cId,
      });
      this.setState({ quizDetails: response.data || [] });
    } catch (error) {
      console.error("Error fetching quiz data:", error);
    }
  };

  componentDidMount() {
    console.log("componentDidMount");
    this.listUserCourseData(0, 10);
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.adminSelectedData &&
      prevProps.adminSelectedData &&
      this.props.adminSelectedData._id !== prevProps.adminSelectedData._id
    ) {
      this.listUserCourseData(0, 10);
      this.fetchData();
    } else if (this.props.adminSelectedData && !prevProps.adminSelectedData) {
      this.listUserCourseData(0, 10);
      this.fetchData();
    }
  }
  render() {
    const { listUserCourseData, type, loginUserData } = this.props;
    // console.log(loginUserData)

    console.log(listUserCourseData);

    let userRole = "";
    if (loginUserData && loginUserData.role) {
      userRole = loginUserData.role;
    } else {
      try {
        const serializedState = localStorage.getItem("state");
        if (serializedState) {
          const parsedState = JSON.parse(serializedState);
          if (parsedState && parsedState.auth && parsedState.auth.loginUserData) {
            userRole = parsedState.auth.loginUserData.role;
          }
        }
      } catch (e) {}
    }

    let displayColumns = [...this.columns];
    const canEdit = checkPermission(loginUserData, "user", "edit");

    if (type === "inprogess") {
      displayColumns = displayColumns.filter(
        (item) =>
          ![
            "completedAt",
            "score",
            "action",
            "course_reset",
            "course_review",
            "certificate_issue_date",
          ].includes(item.key)
      );
      // Always show column, but individual button handles disable state
    }
    if (type === "completed") {
      displayColumns = displayColumns.filter(
        (item) =>
          ![
            "progress",
            "actionss",
            "start_date",
            "expected_end_date",
            "current_topic",
            "avg_time_spend",
            "accessed_date",
          ].includes(item.key)
      );
    }
    return (
      <div>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={displayColumns}
          size={"small"}
          dataSource={listUserCourseData}
          onChange={this.handleTableChange}
        />

        <div style={{ overflowX: "auto" }}>
          <CustomModal
            title="Quiz Details"
            visible={this.state.showCoursesModal}
            onCancel={this.closeModal}
            footer={null}
            maskClosable={false}
            width={1000}
          >
            {this.state.selectedCourse && (
              <PreviewTopicQuiz
                adminSelectedData={this.props.adminSelectedData}
                userId={this.state.selectedCourse.userId}
                courseId={this.state.selectedCourse.courseId}
                data={this.state.quizDetails}
              />
            )}
          </CustomModal>
        </div>

        {/* Edit Date Modal */}
        {this.state.showEditDateModal && (
          <EditDateModal
            visible={this.state.showEditDateModal}
            onClose={this.closeEditDateModal} // Function to close modal
            selectedItem={this.state.selectedItem} // Pass selected data
            authToken={this.props.authToken}
            userId={this.state.selectedCourse.userId}
            courseId={this.state.selectedCourse.courseId}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
  listUserCourseData: state.user.listUserCourseData,
  listUserDataTotal: state.user.listUserDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListUserCourseData: (listUserCourseData) => {
      dispatch({
        type: "SET_LIST_USER_COURSE_DATA",
        listUserCourseData: listUserCourseData,
      });
    },
    setListUserDataTotal: (listUserDataTotal) => {
      dispatch({
        type: "SET_LIST_USER_DATA_TOTAL",
        listUserDataTotal: listUserDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ListUserCourseData));
